"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const buildMarkdownParser_1 = require("./buildMarkdownParser");
function Markdown({ markdown, onClick }) {
    const md = (0, buildMarkdownParser_1.buildMarkdownParser)();
    if (typeof markdown === 'string') {
        markdown = [markdown];
    }
    return (react_1.default.createElement(styles_1.MarkdownContainer, { dangerouslySetInnerHTML: { __html: md.render(markdown === null || markdown === void 0 ? void 0 : markdown.join('\n')) }, onClick: onClick }));
}
exports.default = Markdown;
//# sourceMappingURL=Markdown.js.map